import React from 'react';
import { Input } from '../../components/ui/input';

const ScheduleRideForm = ({
  scheduledDate,
  scheduledTime,
  onDateChange,
  onTimeChange
}) => {
  return (
    <div className="space-y-3 p-4 bg-pink-50 rounded-xl border border-pink-100">
      <div className="text-sm font-medium text-pink-900 mb-2">
        When do you need the ride?
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Date</label>
          <Input
            type="date"
            value={scheduledDate}
            onChange={(e) => onDateChange(e.target.value)}
            min={new Date().toISOString().split('T')[0]}
            max={new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
            className="border-pink-200 focus:border-pink-500 focus:ring-pink-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Time</label>
          <Input
            type="time"
            value={scheduledTime}
            onChange={(e) => onTimeChange(e.target.value)}
            className="border-pink-200 focus:border-pink-500 focus:ring-pink-500"
          />
        </div>
      </div>
      <p className="text-xs text-pink-700">
        You can schedule rides up to 7 days in advance
      </p>
    </div>
  );
};

export default ScheduleRideForm;
